import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { FaBuilding } from "react-icons/fa";
import Layout from "../../components/Layout";
import api, { apiCRMv3 } from "../../services/api";
import * as moment from "moment-timezone";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

const CrmBranchesRegionalData = (props) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const regional = params.get("regional");
    const [branch, setBranch] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [clientListSended, setClientListSended] = useState([]);
    const [birthday, setBirthday] = useState([]);
    const [birthdayToday, setBirthdayToday] = useState([]);
    const [birthdaySended, setBirthdaySended] = useState([]);
    const [buyIntention, setBuyIntention] = useState([]);
    const [buyIntentionSended, setBuyIntentionSended] = useState([]);
    const [easyBuy, setEasyBuy] = useState([]);
    const [easyBuySended, setEasyBuySended] = useState([]);
    const [eligibleWarranty, setEligibleWarranty] = useState([]);
    const [eligibleWarrantySended, setEligibleWarrantySended] = useState([]);
    const [lostClick, setLostClick] = useState([]);
    const [lostClickSended, setLostClickSended] = useState([]);
    const [rightTime, setRightTime] = useState([]);
    const [rightTimeSended, setRightTimeSended] = useState([]);
    const [smartList, setSmartList] = useState([]);
    const [smartListSended, setSmartListSended] = useState([]);
    const [totalAvailable, setTotalAvailable] = useState([]);
    const [totalSent, setTotalSent] = useState([]);
    const [totalSentToday, setTotalSentToday] = useState([]);
    const [expressSentMounth, setExpressSentMounth] = useState([])
    const [expressSentToday, setExpressSentToday] = useState([])
    const [resultado, setResultado] = useState([])
    const [loaded, setLoaded] = useState(false);
    const [show, setShow] = useState(false);
    const [birthdayTodayShow, setBirthdayTodayShow] = useState([]);
    const [loading, setLoading] = useState(false);
    const userRole = localStorage.getItem("user_type");

    useEffect(() => {
        const start = moment.tz("America/Sao_Paulo").startOf("month").format("YYYY-MM-DD");
        const end = moment.tz("America/Sao_Paulo").endOf("month").format("YYYY-MM-DD");
        const startDay = moment.tz("America/Sao_Paulo").startOf("day").format("YYYY-MM-DD");
        const endDay = moment.tz("America/Sao_Paulo").endOf("day").format("YYYY-MM-DD");
        loadList(start, end, regional);
        loadSentToday(startDay, endDay, regional)
        loadExpressSent(start, end, regional)
        loadExpressSentToday(start, end, regional)
    }, []);

    async function loadList(start, end) {
        setLoaded(false);
        const response = await apiCRMv3.get("/crm-analysis/branches-by-regional", {
            params: { start, end, regional },
        });
        const data = response.data.data;
        setBranch(data.filiais);
        setClientList(data.clientList);
        setClientListSended(data.clientListSended);
        setBirthday(data.birthday);
        setBirthdayToday(data.birthdayToday);
        setBirthdaySended(data.birthdaySended);
        setBuyIntention(data.buyIntention);
        setBuyIntentionSended(data.buyIntentionSended)
        setEasyBuy(data.easyBuy);
        setEasyBuySended(data.easyBuySended);
        setEligibleWarranty(data.eligibleWarranty);
        setEligibleWarrantySended(data.eligibleWarrantySended);
        setLostClick(data.lostClick);
        setLostClickSended(data.lostClickSended);
        setRightTime(data.rightTime);
        setRightTimeSended(data.rightTimeSended);
        setSmartList(data.smartList);
        setSmartListSended(data.smartListSended);
        setTotalAvailable(data.totalAvailable);
        setTotalSent(data.totalSent)
        setLoaded(true);
    }

    async function loadSentToday(start, end, regional) {
        const response = await apiCRMv3.get("/crm-analysis/sent-today-regional", {
            params: { start, end, regional }
        });
        const data = response?.data?.data;
        setTotalSentToday(data.totalSentToday)
    }

    async function loadExpressSent(start, end, regional) {
        const response = await api.get("/card/count-sent-month-regional", {
            params: { start, end, regional }
        });
        const data = response.data.qtdCards;
        setExpressSentMounth(data)
    }

    async function loadExpressSentToday(start, end, regional) {
        const response = await api.get("/card/sent-today-regional", {
            params: { start, end, regional }
        });
        const data = response?.data?.qtdCards;
        setExpressSentToday(data)
    }

    const cards = [
        { title: "Funil 2.0", sended: clientListSended, available: clientList },
        { title: "Aniversariantes", sended: birthdaySended, available: birthday, extra: `Aniversariando Hoje: ${birthdayToday}` },
        { title: "Intenções de Compra", sended: buyIntentionSended, available: buyIntention },
        { title: "Pagando Últ. Parcelas", sended: easyBuySended, available: easyBuy },
        { title: "Garantias Elegíveis", sended: eligibleWarrantySended, available: eligibleWarranty },
        { title: "Remarketing", sended: lostClickSended, available: lostClick },
        { title: "Inativos", sended: rightTimeSended, available: rightTime },
        { title: "Funil 3.0", sended: smartListSended, available: smartList },
    ];

    const data = [
        { title: "Disponíveis Para envio", available: totalAvailable },
        { title: "Enviados CRM Acumulados", sended: totalSent },
        { title: "Express Acumulados Mes", sended: expressSentMounth },
        { title: "CRM Enviados Hoje", sended: totalSentToday },
        { title: "Express Enviados Hoje", sended: expressSentToday },
    ];

    async function getDetails(branchId, longCode) {
        if (!branchId) {
            console.error("❌ ID da filial não encontrado:", branchId);
            return;
        }
        props.history.push(`/branch-crm-details?branchId=${branchId}&longCode=${longCode}`);
    }

    const showBirthdaysToday = async () => {
        setShow(true);
        setLoading(true);
        setLoaded(true);
        try {
            const start = moment.tz("America/Sao_Paulo").startOf("month").format("YYYY-MM-DD");
            const end = moment.tz("America/Sao_Paulo").endOf("month").format("YYYY-MM-DD");
            const response = await apiCRMv3.get("/crm-analysis/birthdays-today", {
                params: { start, end, regional },
            });
            setBirthdayTodayShow(response.data?.data?.birthdayToday || []);
        } catch (error) {
            console.error("Erro ao buscar aniversariantes:", error);
        } finally {
            setLoading(false);
            setLoaded(false);
        }
    };
    async function getReportCrmDataRegional() {
        try {
            const start = moment.tz("America/Sao_Paulo").startOf("month").format("YYYY-MM-DD");
            const end = moment.tz("America/Sao_Paulo").endOf("month").format("YYYY-MM-DD");
            setLoaded(false);
            const response = await apiCRMv3.get(`/crm-analysis/export-by-regional`, {
                params: {
                    start,
                    end,
                    
                },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `dados_crm_regional.xlsx`); // nome do arquivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            Swal.fire("Sucesso!", "O relatório foi baixado com sucesso!", "success");

            setLoaded(true);

        } catch (err) {
            console.log(err);
            Swal.fire("Erro!", "Problemas ao gerar o relatório. Por favor contate o suporte!", "error");
            setLoaded(true);
        }
    }
    const closeModal = () => {
        setShow(false)
        setLoaded(true)
    };
    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
        },
        modal: {
            backgroundColor: "#fff",
            borderRadius: "10px",
            width: "90%",
            maxWidth: "900px",
            maxHeight: "80vh",
            overflowY: "auto",
            boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            display: "flex",
            flexDirection: "column",
        },
        header: {
            padding: "16px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        closeButton: {
            border: "none",
            background: "transparent",
            fontSize: "18px",
            cursor: "pointer",
        },
        body: {
            padding: "16px",
        },
        table: {
            width: "100%",
            borderCollapse: "collapse",
        },
        footer: {
            padding: "12px",
            borderTop: "1px solid #ddd",
            textAlign: "right",
        },
        buttonClose: {
            padding: "8px 16px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
        },
    };

    return (
        <Layout menuActive="registers" pageTitle="Dados Regional">
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">Dados Regional</div>
                        </div>
                        <div className={`card-body ${loaded ? "" : "__loading"}`}>
                            <div className="row" style={{ marginLeft: "50px", alignItems: "center", justifyContent: "center" }}>
                                <div className="col-xs-6">
                                    <div style={{ flex: "1", display: "flex", flexDirection: "row", gap: "20px", }}>
                                        {data.map((card, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "12px",
                                                    padding: "20px",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                                    transition: "transform 0.2s",
                                                    cursor: card.title === "Aniversariantes" ? "pointer" : "default",
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                                                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px", width:"220px" }}>
                                                    <FaBuilding size={20} color="#095077" style={{ marginRight: "10px" }} />
                                                    <h3 style={{ margin: 0 }}>{card.title}</h3>
                                                </div>
                                                <h2>{card.sended}</h2>
                                                <h2>{card.available}</h2>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div style={{ marginBottom: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    {userRole === "3" && (
                                        <button
                                            className="btn btn-success btn-large"
                                            type="button"
                                            onClick={() => getReportCrmDataRegional()}
                                        >
                                            Exportar Dados
                                        </button>
                                    )}
                                </div>
                            </div>
                            <br></br>
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-start",
                                gap: "30px"
                            }}>
                                {/* Coluna dos Cards */}
                                <div className="col-xs-4">
                                    <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "20px" }}>
                                        {cards.map((card, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "12px",
                                                    padding: "20px",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                                    transition: "transform 0.2s",
                                                    cursor: card.title === "Aniversariantes" ? "pointer" : "default",
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                                                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                                                onClick={card.title === "Aniversariantes" ? showBirthdaysToday : undefined}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                    <FaBuilding size={20} color="#095077" style={{ marginRight: "10px" }} />
                                                    <h3 style={{ margin: 0 }}>{card.title}</h3>
                                                </div>
                                                <h4>Enviados: {card.sended}</h4>
                                                <h4>Disponíveis: {card.available}</h4>
                                                {card.extra && <h4>{card.extra}</h4>}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {show && (
                                    <div style={styles.overlay}>
                                        <div style={styles.modal}>
                                            <div style={styles.header}>
                                                <h2>Aniversariantes do Dia</h2>
                                                <button style={styles.closeButton} onClick={closeModal}>
                                                    ✖
                                                </button>
                                            </div>

                                            <div style={styles.body}>
                                                {loading ? (
                                                    <p style={{ textAlign: "center" }}>Carregando...</p>
                                                ) : birthdayTodayShow.length === 0 ? (
                                                    <p style={{ textAlign: "center" }}>
                                                        Nenhum aniversariante encontrado neste período.
                                                    </p>
                                                ) : (
                                                    <table style={styles.table}>
                                                        <thead>
                                                            <tr>
                                                                <th>Filial</th>
                                                                <th>Vendedor</th>
                                                                {/* <th>CPF Vendedor</th> */}
                                                                <th>Cliente</th>
                                                                <th>CPF Cliente</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {birthdayTodayShow.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{item.br_longCode || "-"}</td>
                                                                    <td>{item.username || "-"}</td>
                                                                    {/* <td>{item.usercpf || "-"}</td> */}
                                                                    <td>{item.clientname || "-"}</td>
                                                                    <td>{item.clientcpf || "-"}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>

                                            <div style={styles.footer}>
                                                <button onClick={closeModal} style={styles.buttonClose}>
                                                    Fechar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div style={{
                                    width: "550px",
                                    background: "#fff",
                                    borderRadius: "12px",
                                    padding: "20px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                    maxHeight: "620px",
                                    overflowY: "auto",
                                }}>
                                    <h4 style={{ marginBottom: "15px" }}>Filiais</h4>
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Filial</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {branch.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data.b_longCode}</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-large"
                                                            type="button" onClick={(e) => {
                                                                getDetails(data.b_id, data.b_longCode)
                                                            }}>
                                                            Detalhes
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(CrmBranchesRegionalData);

